import { TranslationLanguage } from './constants';

const translationLanguages = Object.values(TranslationLanguage);

/**
 * Normalizes an arbitrary locale string (e.g. `cs`, `EN_US`, `en-us`) into a
 * valid {@link TranslationLanguage}. Falls back to Czech when the value cannot
 * be matched against a supported language.
 */
export const toTranslationLanguage = (locale?: string | null): TranslationLanguage => {
    if (!locale) {
        return TranslationLanguage.EN_GB;
    }

    const normalized = locale.replace('_', '-');
    const lowerCased = normalized.toLowerCase();

    const match = translationLanguages.find((language) => language.toLowerCase() === lowerCased);
    if (match) {
        return match;
    }

    // Try matching only the root language part (e.g. `en-AU` -> `en-GB`).
    const [root] = lowerCased.split('-');
    const rootMatch = translationLanguages.find((language) => language.toLowerCase().split('-')[0] === root);
    if (rootMatch) {
        return rootMatch;
    }

    return TranslationLanguage.CS;
};
